export var AlertOverrides = function (theme) {
    var _a, _b, _c;
    return ({
        MuiAlert: {
            root: (_a = {
                    // Reset styles from material-ui that we don't want
                    fontSize: 14,
                    borderRadius: 0,
                    backgroundColor: theme.palette.background.default
                },
                _a[theme.breakpoints.up('sm')] = {
                    padding: '12px 16px',
                    flexWrap: 'nowrap',
                    alignItems: 'center',
                },
                _a[theme.breakpoints.up('md')] = {
                    padding: '12px 32px',
                },
                _a.alignItems = 'flex-start',
                _a.flexWrap = 'wrap',
                _a.padding = '12px 12px',
                _a),
            icon: (_b = {
                    padding: 0,
                    marginRight: 8,
                    opacity: 1,
                    alignSelf: 'flex-start'
                },
                _b[theme.breakpoints.up('sm')] = {
                    alignSelf: 'center',
                },
                _b),
            action: (_c = {
                    // Reset styles from material-ui
                    marginRight: 0,
                    display: 'flex',
                    flexWrap: 'wrap',
                    // This gets overridden by the `dismissAction` class, so the dismiss action will be aligned to the top
                    alignItems: 'center'
                },
                _c[theme.breakpoints.up('sm')] = {
                    paddingLeft: 8,
                },
                _c.paddingLeft = 0,
                _c),
            message: {
                padding: 0,
                // Having a 50% flex basis allows the buttons to wrap when in small breakpoints
                flex: '1 1 50%',
            },
            standardInfo: {
                backgroundColor: theme.palette.info.light,
                color: theme.palette.text.primary,
                '& $icon': {
                    color: theme.palette.text.primary,
                },
            },
            standardError: {
                backgroundColor: theme.palette.error.light,
                color: theme.palette.text.primary,
                '& $icon': {
                    color: theme.palette.text.primary,
                },
            },
            standardSuccess: {
                backgroundColor: theme.palette.success.light,
                color: theme.palette.text.primary,
                '& $icon': {
                    color: theme.palette.text.primary,
                },
            },
            standardWarning: {
                backgroundColor: theme.palette.warning.light,
                color: theme.palette.type === 'light' ? theme.palette.text.primary : theme.palette.background.b1,
                '& $icon': {
                    color: theme.palette.type === 'light'
                        ? theme.palette.primary.main
                        : theme.palette.primary.contrastText,
                },
            },
        },
    });
};
//# sourceMappingURL=Banner.overrides.js.map